import { render } from "./Status.vue?vue&type=template&id=20cfb36e&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "../assets/css/status/style.css?vue&type=style&index=0&id=20cfb36e&scoped=true&lang=css&external"
import "./Status.vue?vue&type=style&index=1&id=20cfb36e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cfb36e"]])

export default __exports__